export default __webpack_public_path__ + "static/favicon-e2f2ae2e556ca8972432d5b2d6e88709.ico";